import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Stack } from '@mui/material'
import noop from 'lodash/noop'
import PricingFormulaTable from 'components/generic/table/PricingFormulaTable'

const PricingForm = ({ control, watch, setValue }) => {
  return (
    <Stack key="pricing" flexGrow={1} ml={4}>
      <Typography variant="h5" mb={3}>
        Pricing
      </Typography>
      <PricingFormulaTable control={control} watch={watch} setValue={setValue} />
    </Stack>
  )
}

PricingForm.propTypes = {
  control: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func,
}

PricingForm.defaultProps = {
  control: {},
  watch: noop,
  setValue: noop,
}

export default PricingForm
